import { gql } from '@apollo/client';

import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const lessonPrintablesFragment = gql`
  fragment LessonPrintablesFragment on Lesson {
    id
    printableLessonPlan {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableWorksheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableAnswerSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableSupportSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableExtensionSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableVocabularyEnSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableVocabularyEsSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableTeacherInformationSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableLessonRubricSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;

export const DELETE_LESSON_PRINTABLE_WORKSHEET = gql`
  mutation DeleteLessonPrintableWorksheet($input: DeleteLessonPrintableInput!) {
    deleteLessonPrintableWorksheet(input: $input) {
      ...LessonPrintablesFragment
    }
  }
  ${lessonPrintablesFragment}
`;

export const ADD_LESSON_PRINTABLE_WORKSHEET = gql`
  mutation AddLessonPrintableWorksheet($input: AddLessonPrintableInput!) {
    addLessonPrintableWorksheet(input: $input) {
      ...LessonPrintablesFragment
    }
  }
  ${lessonPrintablesFragment}
`;
